import React from "react";
import {
    Row, Col, Label, Modal, ModalHeader, ModalBody, ModalFooter, Button
} from "reactstrap";
import DatePicker from "react-datepicker";
import { Calendar } from "react-feather";
import RegistrarAsistenciaModal from "./modals/RegistrarAsistenciaModal";
import CancelarReservaModal from "./modals/CancelarReservaModal";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ClassDayCard from "components/shared/ClassDayCard";
import { useClasePorDia } from "hooks/useClasePorDia";
import "react-datepicker/dist/react-datepicker.css";
import "./app.css";
import ClientDetail from "./Details/ClientDetail";

function ClasePorDia() {
    const {
        date,
        setDate,
        slots,
        bookings,
        selectedClass,
        modalOpen,
        setModalOpen,
        cancelModalOpen,
        setCancelModalOpen,
        selectedBooking,
        loading,
        loadingClients,
        setLoadingClients,
        modalDetalleOpen,
        setModalDetalleOpen,
        alumnoSeleccionado,
        historialCliente,
        asistenciaModalOpen,
        setAsistenciaModalOpen,
        reservaSeleccionada,
        isAdmin,
        asistenciaDisplay,
        openAsistenciaModal,
        handleConfirmarAsistencia,
        openDetalleModal,
        openModal,
        openCancelModal,
        getAlumnos,
        fetchAll
    } = useClasePorDia();

    return (
        <LoadingOverlay loading={loading}>
            <div className="content">
                <Row className="mb-4 align-items-center">
                    <Col md="5">
                        <h4 className="mb-0">Agenda y asistencia por día</h4>
                        <p className="text-muted" style={{ fontSize: '0.9rem' }}>
                            Selecciona una fecha y revisa quién está inscrito.
                        </p>
                    </Col>
                    <Col md="4">
                        <Label className="d-flex align-items-center">
                            <Calendar size={18} className="mr-2" />
                            <DatePicker
                                selected={date}
                                onChange={(d) => setDate(d)}
                                dateFormat="yyyy-MM-dd"
                                className="form-control ml-2"
                            />
                        </Label>
                    </Col>
                    <Col md="3" className="text-right">
                        <Button 
                            color="primary" 
                            size="sm" 
                            onClick={() => fetchAll()}
                            disabled={loading}
                            className="d-flex align-items-center"
                        >
                            {loading ? 'Cargando...' : 'Recargar'}
                        </Button>
                    </Col>
                </Row>

                {slots.length === 0 ? (
                    <p className="text-muted">No hay clases programadas para esta fecha.</p>
                ) : (
                    slots.map((slot, idx) => {
                        const alumnos = getAlumnos(slot.schedule_id);
                        return (
                            <ClassDayCard
                                key={idx}
                                slot={slot}
                                alumnos={alumnos}
                                isAdmin={isAdmin}
                                asistenciaDisplay={asistenciaDisplay}
                                onOpenModal={openModal}
                                onOpenCancelModal={openCancelModal}
                                onOpenAsistenciaModal={openAsistenciaModal}
                                onOpenDetalleModal={openDetalleModal}
                            />
                        );
                    })
                )}

                {alumnoSeleccionado && (
                    <Modal isOpen={modalDetalleOpen} toggle={() => setModalDetalleOpen(false)} size="lg">
                        <ModalHeader toggle={() => setModalDetalleOpen(false)}>
                            Detalle del Alumno
                        </ModalHeader>
                        <ModalBody>
                            <ClientDetail client={alumnoSeleccionado} mode="view" classHistory={historialCliente} />
                        </ModalBody>
                    </Modal>
                )}

                <RegistrarAsistenciaModal
                    isOpen={modalOpen}
                    toggle={() => setModalOpen(!modalOpen)}
                    clase={selectedClass}
                    fecha={date}
                    bookings={bookings}
                    loadingClients={loadingClients}
                    setLoadingClients={setLoadingClients}
                    onRegisterSuccess={() => {
                        setModalOpen(false);
                        fetchAll();
                    }}
                />

                <CancelarReservaModal
                    isOpen={cancelModalOpen}
                    toggle={() => setCancelModalOpen(!cancelModalOpen)}
                    booking={selectedBooking}
                    onCancelSuccess={() => {
                        setCancelModalOpen(false);
                        fetchAll();
                    }}
                />

                <Modal isOpen={asistenciaModalOpen} toggle={() => setAsistenciaModalOpen(false)}>
                    <ModalHeader toggle={() => setAsistenciaModalOpen(false)}>
                        Marcar asistencia
                    </ModalHeader>
                    <ModalBody>
                        <p>¿Qué estado deseas asignar al alumno <strong>{reservaSeleccionada?.client}</strong>?</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="success"
                            onClick={() => handleConfirmarAsistencia("attended")}
                            className="btn-anadir"
                            style={{ marginRight: "1vh" }}
                        >
                            Asistió
                        </Button>
                        <Button
                            color="warning"
                            onClick={() => handleConfirmarAsistencia("pending")}
                            className="btn-no"
                            style={{ marginRight: "1vh" }}
                        >
                            Pendiente
                        </Button>
                        <Button
                            color="warning"
                            onClick={() => handleConfirmarAsistencia("no_show")}
                            className="btn-cerrar"
                            style={{ marginRight: "1vh" }}
                        >
                            No asistió
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </LoadingOverlay>
    );
}

export default ClasePorDia;